import { render, staticRenderFns } from "./ZhanbanDataLight.vue?vue&type=template&id=0b617260&scoped=true"
import script from "./ZhanbanDataLight.vue?vue&type=script&lang=js"
export * from "./ZhanbanDataLight.vue?vue&type=script&lang=js"
import style0 from "./ZhanbanDataLight.vue?vue&type=style&index=0&id=0b617260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b617260",
  null
  
)

export default component.exports